import { useCallback, useState } from 'react'
import type { PreviewDocument } from '../features/preview/components/document-preview-modal'

interface UseDocumentPreviewOptions {
  fetchDocumentUrl: (documentId: string) => Promise<string>
}

interface UseDocumentPreviewReturn {
  previewDoc: PreviewDocument | null
  previewOpen: boolean
  setPreviewOpen: (open: boolean) => void
  openDocument: (doc: PreviewDocument) => void
  fetchDocumentUrl: (documentId: string) => Promise<string>
}

export function useDocumentPreview({
  fetchDocumentUrl,
}: UseDocumentPreviewOptions): UseDocumentPreviewReturn {
  const [previewDoc, setPreviewDoc] = useState<PreviewDocument | null>(null)
  const [previewOpen, setPreviewOpen] = useState(false)

  const openDocument = useCallback((doc: PreviewDocument) => {
    setPreviewDoc(doc)
    setPreviewOpen(true)
  }, [])

  return {
    previewDoc,
    previewOpen,
    setPreviewOpen,
    openDocument,
    fetchDocumentUrl,
  }
}
